// extracted by css-extract-rspack-plugin
export default {"root":"si5XO8","content":"pLPkQA"};